import { render, staticRenderFns } from "./VueSelectField.vue?vue&type=template&id=696e36ac&scoped=true"
import script from "./VueSelectField.vue?vue&type=script&lang=ts"
export * from "./VueSelectField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696e36ac",
  null
  
)

export default component.exports